import { cloneDeep, isEqual } from 'lodash';
import React, { Component } from 'react';

import { session } from 'services/session';
import dashboardService from './dashboard-service';
import { dateService } from '../../../services/date';
import { formatValue } from '../../base/common/utils';
import { Loader, NoResult } from 'components/misc/loader-utils';

import './barometers.scss';
import './change-icons.scss';

class Barometers extends Component {
	constructor(props) {
		super(props);

		this.service = dashboardService;

		const statTemplate = {
			thisMonth: 0,
			lastMonth: 0,
			percentChange: 0,
			projected: 0,
		};
		const primaryTemplate = [
			{
				name: 'clicks',
				label: 'Clicks',
			},
			{
				name: 'publisher_epc',
				label: 'Avg. EPC',
				type: 'currency',
			},
			{
				name: 'publisher_total_earnings',
				label: 'Earnings',
				type: 'currency',
			},
		];

		const secondaryTemplate = [
			{
				name: 'clicks',
				label: 'Clicks',
			},
			{
				name: 'publisher_rpc',
				label: 'Avg. RPC',
				type: 'currency',
			},
			{
				name: 'total_attributed_revenue',
				label: 'Revenue',
				type: 'currency',
			},
		];
		// for ease of testing
		const dataTemplate = session.isOrgAdmin ? primaryTemplate : secondaryTemplate;
		this.state = {
			loading: true,
			showNoResult: false,
			barometerData: dataTemplate.map((statField) => {
				return Object.assign(statField, statTemplate);
			}),
		};
	}

	componentDidMount() {
		this.queryEarningsStats();
	}

	componentDidUpdate(prevProps, _) {
		if (!isEqual(prevProps.networks, this.props.networks)) {
			this.setState({loading: true}, () => {
				this.queryEarningsStats();
			});
		}
	}

	queryEarningsStats() {
		const presetRanges = dateService.getPresetDateRanges();
		const lastMonthStart = presetRanges.lastMonth.startDate;
		const thisMonthEnd = presetRanges.thisMonth.endDate;

		const params = {
			date_from: dateService.formatDate(lastMonthStart),
			date_to: dateService.formatDate(thisMonthEnd),
		};
		const networks = this.props.networks.filter((network) => network.selected)
			.map((network) => network.name).join(',');

		return this.service.getStatsByMonth(
			this.props.pubId, Object.assign(params, {networks: networks})
		).then((data) => {
			if (!data.length) {
				this.showNoResult();
				return;
			}

			this.setState({
				loading: false,
				showNoResult: false,
				barometerData: this.processStats(data),
			});
		}, () => {
			this.showNoResult();
		});
	}

	/* Helper functions */
	processStats(data) {
		return cloneDeep(this.state.barometerData).map((statField) => {
			statField.lastMonth = data[0][statField.name];
			statField.thisMonth = data[1][statField.name];

			statField.projected = statField.name === 'publisher_epc' || statField.name === 'publisher_rpc'
				? statField.thisMonth
				: parseFloat(
					(statField.thisMonth / dateService.monthElapsed()).toFixed(2)
				);
			statField.percentChange = this.service.calculatePercentChange(
				parseFloat(statField.projected), parseFloat(statField.lastMonth)
			);
			statField.thisMonth = formatValue(statField.thisMonth, statField.type, statField.name);

			return statField;
		});
	}

	showNoResult() {
		this.setState({
			showNoResult: true,
			loading: false,
		});
	}

	render() {
		const mathIcons = (index) => {
			if (index === 2) return null;
			const type = index === 0 ? 'x-icon' : 'equal';
			return (
				<div className={`icon ${type}`}></div>
			);
		};

		const barometers = !this.state.loading && !this.state.showNoResult ?
			this.state.barometerData.map((statField, index) => {
				const rank = this.service.getRanking(statField.percentChange);

				return (
					<div className={`panel ${statField.name}`} key={index}>
						<div className="name">{statField.label}</div>
						<div className="current-value">{statField.thisMonth}</div>

						<div className={`percent-change ${rank}`}>
							<span className="symbol"></span>
							<span className="value">
								{this.service.displayPercentChange(statField.percentChange)}
							</span>
							<p className="comparison">Vs Last Month</p>
						</div>

						{mathIcons(index)}
					</div>
				);
			}) : null;

		return (
			<div className="barometers-container">
				<Loader loading={this.state.loading} />
				<NoResult
					type="barometers"
					noResult={!this.state.loading && this.state.showNoResult}
				/>
				{barometers}
			</div>
		);
	}
}

export default Barometers;
